import { render, staticRenderFns } from "./AllTasks.vue?vue&type=template&id=994821dc&scoped=true&"
import script from "./AllTasks.vue?vue&type=script&lang=js&"
export * from "./AllTasks.vue?vue&type=script&lang=js&"
import style0 from "./AllTasks.vue?vue&type=style&index=0&id=994821dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994821dc",
  null
  
)

component.options.__file = "AllTasks.vue"
export default component.exports